import { types } from 'mobx-state-tree'
import { Factoid } from '../Factoid'

export const GameChoiceOrdering = types
  .model('Ordering')
  .props({
    index: types.maybe(types.number),
    text: types.string,
    orderedCorrectly: types.maybe(types.boolean),
  })
  .actions((self) => ({
    setText(text: string) {
      self.text = text
    },
    setOrderedCorrectly(correct) {
      self.orderedCorrectly = correct
    },
  }))

export const GameChoicePair = types
  .model('GameChoicePair')
  .props({
    left: types.string,
    right: types.string,
    matchedCorrectly: types.maybe(types.boolean),
  })
  .actions((self) => ({
    setMatchedCorrectly(correct) {
      self.matchedCorrectly = correct
    },
    setLeft(left) {
      self.left = left
    },
    setRight(right) {
      self.right = right
    },
  }))

export const GameChoice = types
  .model('GameChoice')
  .props({
    id: types.identifierNumber,
    text: types.maybeNull(types.string),
    correct: types.boolean,
    factoid: types.maybeNull(Factoid),
    selected: types.maybe(types.boolean),
    pairs: types.maybe(types.array(GameChoicePair)),
    ordering: types.maybe(types.array(GameChoiceOrdering)),
  })
  .actions((self) => ({
    reset() {
      self.selected = false
    },
  }))
  .views((self) => ({
    get display(): any {
      if (self.text?.toLowerCase() === 'true') {
        return 'True'
      } else if (self.text?.toLowerCase() === 'false') {
        return 'False'
      }
      return self.text
    },
  }))
  .actions((self) => ({
    select() {
      if (self.selected) {
        self.selected = false
      } else {
        self.selected = true
      }
    },
  }))
